import { observable, computed, action } from 'mobx';
import { FormField } from '../../../components/form-field';
import { WebGivingMerchant } from '../../../webgiving-generated';
import { SplitLineItem } from '../../../utils/webgiving-utils';
import { getCalculatedAmountWithFees } from '../../../utils/helper-utils';
import { getOverMaxLimitError } from '../../../utils/error-utils';
import { PaymentMethodParams } from '../page-payment-method-view-model';
import { WebGivingError } from '../../../components/error-message/error-message';

export class ApplePaymentMethodViewModel {
	@observable
	amount: number;

	@observable
	payerElectedToCoverFees: FormField<boolean>;

	oneTimeGiftDateLabel: string;

	paymentDetailsText: string;

	fundName: string;

	lineItems: SplitLineItem[];

	@observable
	error: WebGivingError;

	@computed
	get calculatedAmountWithFees() {
		return getCalculatedAmountWithFees(this.lineItems, this.merchantInfo, this.payerElectedToCoverFees.value, this.amount);
	}

	constructor(public merchantInfo: WebGivingMerchant,
		{ amount, electedToCoverFees = false, fundName, paymentDetailsText, oneTimeGiftDateLabel, lineItems }: PaymentMethodParams) {
		this.amount = amount;
		this.payerElectedToCoverFees = FormField.Unvalidated(electedToCoverFees);
		this.oneTimeGiftDateLabel = oneTimeGiftDateLabel;
		this.paymentDetailsText = paymentDetailsText;
		this.fundName = fundName;
		this.lineItems = lineItems;

		this.handleMaxLimitAfterProcessingCosts();
		this.payerElectedToCoverFees.updateSubject.register(() => this.handleMaxLimitAfterProcessingCosts());
	}

	@action.bound
	handleMaxLimitAfterProcessingCosts() {
		// TODO (No ticket yet) Message translation params is tech debt
		this.error = getOverMaxLimitError(this.lineItems, this.payerElectedToCoverFees.value, this.merchantInfo, this.amount);
	}
}
